import type { FC } from 'react'
import { ChevronIcon } from '@chegg-ui/horizon-icons'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { CarouselCardWithImage } from '../utils'
import {
  CarouselContainer,
  CarouselImage,
  LeftArrowButton,
  RightArrowButton,
} from './styled'

interface ImageCarouselProps {
  currentCarouselCard: CarouselCardWithImage
  onLeftArrowClick: () => void
  onRightArrowClick: () => void
  dataTestId?: string
}

export const ImageCarousel: FC<ImageCarouselProps> = ({
  currentCarouselCard,
  onLeftArrowClick,
  onRightArrowClick,
  dataTestId,
}) => {
  return (
    <CarouselContainer data-test={dataTestId}>
      {/* todo - update alt with SEO requirements task */}
      <CarouselImage
        src={publicAssetUrl(currentCarouselCard.carouselImage)}
        alt={currentCarouselCard.content}
      />
      <LeftArrowButton screenReaderOnlyText="carousel-left" onClick={onLeftArrowClick}>
        <ChevronIcon pointing="left" color="white" />
      </LeftArrowButton>
      <RightArrowButton screenReaderOnlyText="carousel-right" onClick={onRightArrowClick}>
        <ChevronIcon pointing="right" color="white" />
      </RightArrowButton>
    </CarouselContainer>
  )
}
